module.exports = __webpack_public_path__ + "static/media/video.2375c061.mp4";